import { useState } from 'react'
import { callApi } from '@/utils/http-utils'

export type NewModality = {
  name: string
  description: string
  keyFeatures?: string
  status?: boolean // default true
  isManualEntry?: boolean // default false
  changeDescription?: string
  createdBy?: string
}

export const useCreateModality = () => {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string>('')

  const createModality = async (payload: NewModality) => {
    setSubmitting(true)
    setError('')
    try {
      const res = await callApi('data-api/modalities', {
        method: 'POST',
        body: payload,
        accept: 'application/json',
      })

      const ct = res.headers.get('content-type') || ''
      if (!ct.includes('application/json')) {
        const text = await res.text()
        throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
      }
      const created = await res.json()
      return created
    } catch (e: any) {
      setError(e?.message || 'Failed to create modality')
      throw e
    } finally {
      setSubmitting(false)
    }
  }

  return { createModality, submitting, error, setError }
}
